import React from "react";
import { object } from "prop-types";

import ComponentContainer from "../../layouts/component-container";
import MobileLayout from "./MobileLayout";
import TabLayout from "./TabLayout";
import DesktopLayout from "./DesktopLayout";

const FourteenStories3Ad1Widget = ({ collection }) => {
  if (!(collection && collection.items && collection.items.length)) return null;

  return (
    <ComponentContainer collection={collection}>
      <MobileLayout collection={collection} />
      <TabLayout collection={collection} />
      <DesktopLayout collection={collection} />
    </ComponentContainer>
  );
};

FourteenStories3Ad1Widget.storyLimit = 21;

FourteenStories3Ad1Widget.propTypes = {
  collection: object.isRequired,
};

export default FourteenStories3Ad1Widget;
